import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Login from '../views/auth/Login'
import ChangePassword from "../views/auth/ChangePassword";

import AddressInterventionIndex from "../views/addressIntervention/AddressInterventionIndex";
import AddressInterventionCreate from "../views/addressIntervention/AddressInterventionCreate";
import AddressInterventionEdit from "../views/addressIntervention/AddressInterventionEdit";
import AddressInterventionShow from "../views/addressIntervention/AddressInterventionShow";

import ClientIndex from "../views/client/ClientIndex"
import ClientCreate from "../views/client/ClientCreate"
import ClientEdit from "../views/client/ClientEdit"
import ClientShow from "../views/client/ClientShow"

import InterventionIndex from "../views/intervention/InterventionIndex"
import InterventionCreate from "../views/intervention/InterventionCreate"
import InterventionEdit from "../views/intervention/InterventionEdit"
import InterventionShow from "../views/intervention/InterventionShow"

import TechnicianIndex from "../views/technician/TechnicianIndex"
import TechnicianCreate from "../views/technician/TechnicianCreate"
import TechnicianEdit from "../views/technician/TechnicianEdit"
import TechnicianShow from "../views/technician/TechnicianShow"

import UserIndex from "../views/user/UserIndex"
import UserCreate from "../views/user/UserCreate"
import UserEdit from "../views/user/UserEdit"
import UserShow from "../views/user/UserShow"

import DeviceShow from "../views/device/DeviceShow"
import DeviceEdit from "../views/device/DeviceEdit"

Vue.use(VueRouter)
const routes = [
  {
    path: '/login/:username?/:password?',
    name: 'Login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/',
    name: 'Home',
    component: InterventionIndex,
    meta: {requiresAuth: true}
  },
  {
    path: '/changePassword/:token?',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {guest: true}
  },

  {
    path: '/addressIntervention/index',
    name: 'AddressInterventionIndex',
    component: AddressInterventionIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/addressIntervention/create',
    name: 'AddressInterventionCreate',
    component: AddressInterventionCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/addressIntervention/edit/:addressInterventionId',
    name: 'AddressInterventionEdit',
    component: AddressInterventionEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/addressIntervention/show/:addressInterventionId',
    name: 'AddressInterventionShow',
    component: AddressInterventionShow,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/client/edit/:clientId',
    name: 'ClientEdit',
    component: ClientEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/client/show/:clientId',
    name: 'ClientShow',
    component: ClientShow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/client/create',
    name: 'ClientCreate',
    component: ClientCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/client/index',
    name: 'ClientIndex',
    component: ClientIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/intervention/edit/:interventionId',
    name: 'InterventionEdit',
    component: InterventionEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/intervention/show/:interventionId',
    name: 'InterventionShow',
    component: InterventionShow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/intervention/create',
    name: 'InterventionCreate',
    component: InterventionCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/intervention/index',
    name: 'InterventionIndex',
    component: InterventionIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/technician/edit/:technicianId',
    name: 'TechnicianEdit',
    component: TechnicianEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/technician/show/:technicianId',
    name: 'TechnicianShow',
    component: TechnicianShow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/technician/create',
    name: 'TechnicianCreate',
    component: TechnicianCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/technician/index',
    name: 'TechnicianIndex',
    component: TechnicianIndex,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/user/edit/:userId',
    name: 'UserEdit',
    component: UserEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/show/:userId',
    name: 'UserShow',
    component: UserShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/create',
    name: 'UserCreate',
    component: UserCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/index',
    name: 'UserIndex',
    component: UserIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },

  {
    path: '/device/show/:deviceId',
    name: 'DeviceShow',
    component: DeviceShow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/device/edit/:deviceId',
    name: 'DeviceEdit',
    component: DeviceEdit,
    meta: {
      requiresAuth: true
    }
  },

]

const router = new VueRouter({
  routes,
  scrollBehavior(from, to, savedPosition){
    window.scrollTo(0, 0)
  }
})

// the meta: {requiresAuth: true} key. If a route has the meta key, it checks the store for a token; if present, it redirects them to the login route.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {

    // Gestion pages réservées à l'admin
    if (to.meta.adminOnly) {
      if (store.getters.isAuthenticated && store.getters.isAdmin) {
        next()
        return
      } else {
        next('/login')
        return
      }
    }

    // Gestion pages réservées aux utilisateurs connectés
    if (store.getters.isAuthenticated) {
      next()
      return
    }

    next('/login')

  } else {
    next()
  }
})

// The meta: {guest: true} stops users that are logged in from accessing the routes with the guest meta.
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/')
      return
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js